import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/global/components.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/widgets/datepicker';
import React, { Component } from 'react';
import TableView from './tableView';
import GraphView from './packageTotalNewRepeatGraphView';
import HistogramByCountryView from './packageHistogramByCountryView';
import HistogramBySourceView from './packageHistogramBySourceView';
import PageTitle from './../../component/pageTitle'
import PackageInventoryView from './packageInventoryGraphView';
import PackagesGraphViewByMonth from './packageTotalNewRepeatGraphByMonthView';

class Dashboard extends Component {
    render() {
        return (
            <div className="page-content-wrapper">
                <PageTitle pageTitle = {"Package Statistics Page"} ></PageTitle>
                <div className="page-content tabbable-custom column-xs-12">
                    <TableView></TableView>
                    <div className="graph-border-without-left-margin">
                        <HistogramBySourceView></HistogramBySourceView>
                    </div>
                </div>
                <div className="graph-border">
                    <HistogramByCountryView></HistogramByCountryView>
                </div>
                <div className="graph-border">
                    <GraphView></GraphView>
                </div>
                <div className="graph-border">
                    <PackagesGraphViewByMonth/>
                </div>
                <div className="graph-border">
                    <PackageInventoryView></PackageInventoryView>
                </div>
            </div>
        );
    }
}

export default Dashboard;